import { z } from 'zod';

export enum SortOptions {
  alphabetical = 'alphabetical',
  featured = 'featured',
  price = 'price',
  priceDesc = 'priceDesc',
  rating = 'rating',
  recommended = 'recommended',
  thcAsc = 'thcAsc',
  thcDesc = 'thcDesc',
}

export const SortOptionsSchema = z.enum(SortOptions);

export enum MenuProductSortSuffix {
  Alphabetical = '',
  Default = '', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  Featured = '', // eslint-disable-line @typescript-eslint/no-duplicate-enum-values
  Price = 'by-price-',
  PriceDesc = 'by-price-desc-',
  Rating = 'by-rating-',
  Recommended = 'by-recommendation-ordinal-asc-',
  ThcAsc = 'by-thc-potency-asc-',
  ThcDesc = 'by-thc-potency-desc-',
}
